import React, { useContext, useEffect, useState } from "react";
import "./blogs.css";
import { Link } from "react-router-dom";
import { server, truncateText } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import configContext from "../../context/configContext/configContext";

const Blogs = () => {
  document.title = "Blogs";
  const [blogs, setBlogs] = useState([]);
  const [industryblogs, setIndustryBlogs] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);

  useEffect(() => {
    getData();
    getIndustryData();
  }, []);

  // Get
  const getData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/blog/getallblogs", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setBlogs(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/blogs/getallind_blogs", {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryBlogs(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  // search
  const SearchData = (searchValue) => {
    server
      .get(`/blogs/searchallblogs?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setBlogs(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // search filter wise
  const FilterData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/blogs/filter?filterByDate=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setBlogs(response.data);
          setIndustryBlogs(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // const blogs = [
  //   {
  //     id: 1,
  //     title: "Winner Announcement Blog For Natural Farming Quiz",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1685431917122933441.jpg",
  //     date: "20 sep",
  //     desc: "Natural Farming has been identified as a promising tool to minimize the dependen ...",
  //   },
  //   {
  //     id: 2,
  //     title:
  //       "Winner Announcement of Water Heroes – Share Your Stories Contest 3.0 for the month of November 2022",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1675082302111185571.jpg",
  //     date: "20 sep",
  //     desc: "In an attempt to promote value of water in general and for supporting country-wi ...",
  //   },
  //   {
  //     id: 3,
  //     title: "Winner Announcement for the Logo Design Competition for G20-DIA",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1684409135122933441.jpg",
  //     date: "20 sep",
  //     desc: "MeitY Startup Hub (MSH) was established as Independent Business Division (IBD) w ...",
  //   },
  //   {
  //     id: 4,
  //     title:
  //       "Winner Announcement Blog for Logo Design Competition for Firozabad Glass Industry",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1674038493111185571.jpg",
  //     date: "20 sep",
  //     desc: "District Export Committee, Firozabad conducted a logo designing competition for ...",
  //   },
  //   {
  //     id: 5,
  //     title: "Winner Announcement for Veergatha 2.0",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1672828770111185571.jpg",
  //     date: "20 sep",
  //     desc: "Veergatha 1.0 was received very enthusiastically pan India. Inspired by its succ ...",
  //   },
  //   {
  //     id: 6,
  //     title:
  //       "Winner Announcement for Quiz on the occasion of Golden Jubilee of Postal Index Number (PIN), Department of Posts",
  //     img: "https://static.mygov.in/static/s3fs-public/mygov_1668420080110258821.jpg",
  //     date: "20 sep",
  //     desc: "On Golden Jubilee of Postal Index Number (PIN), the Department of Posts conducte ...",
  //   },
  // ];

  // for to display only 20 words description

  return (
    <>
      <section style={{ marginTop: "1rem" }}>
        <div className="container-xl">
          <div className="text-center mb-5">
            <h2 className="display-20 display-md-18 display-lg-16 my-4">
              Blogs
            </h2>
          </div>

          <div className="row my-3">
            <div className="col-md-4">
              <select
                className="form-control"
                name=""
                id=""
                onChange={(e) => FilterData(e)} // Pass the event to FilterData
              >
                <option value="industry">Industry</option>
                <option value="institute">Institute</option>
                <option value="university">University</option>
              </select>
            </div>
            <div className="col-md-4 my-1">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                onChange={(e) => SearchData(e.target.value)}
              />
            </div>
            <div className="col-md-4 my-1">
              <select
                className="form-control"
                name=""
                id=""
                onChange={(e) => FilterData(e)} // Pass the event to FilterData
              >
                <option value="2days" defaultValue>
                  Last 2 days
                </option>
                <option value="month" defaultValue>
                  This Month
                </option>
                <option value="3months">Last 3 Months</option>
                <option value="6months">Last 6 Months</option>
              </select>
            </div>
          </div>
          <div className="row">
            {blogs &&
              blogs?.map((item) => {
                return (
                  <>
                    <div className="col-lg-4 col-md-6 mb-3" key={item.id}>
                      <article
                        className="card card-style2"
                        style={{ height: "35rem" }}
                      >
                        <div className="card-img">
                          <img
                            className="rounded-top "
                            style={{ height: "16rem" }}
                            src={item.image}
                            alt="..."
                          />
                          <div className="date">
                            <span>Post on : {item.Date}</span>
                          </div>
                        </div>

                        <div className="card-body">
                          <h3 className="h5">
                            <a href="#!">{item.title}</a>
                          </h3>
                          <p>Category : {item.category}</p>
                          <p>{truncateText(item.description, 20)}</p>{" "}
                          <button className="btn btn-dark btn-sm">
                            <Link
                              className="text-white text-decoration-none"
                              to={`/adminblogs/${item.id}`}
                            >
                              Read More
                            </Link>
                          </button>
                        </div>
                      </article>
                    </div>
                  </>
                );
              })}
            {industryblogs &&
              industryblogs
                .filter((item) => item.status === "Post")
                .map((item) => {
                  return (
                    <>
                      <div className="col-lg-4 col-md-6 mb-3" key={item.id}>
                        <article
                          className="card card-style2"
                          style={{ height: "35rem" }}
                        >
                          <div className="card-img">
                            <img
                              className="rounded-top "
                              src={item.image}
                              style={{ height: "16rem" }}
                              alt="..."
                            />
                            <div className="date">
                              <span>Post on : {item.date}</span>
                            </div>
                          </div>

                          <div className="card-body">
                            <h3 className="h5">
                              <a href="#!">{item.title}</a>
                            </h3>
                            <p>Category : {item.category}</p>
                            <p>{truncateText(item.description, 20)}</p>{" "}
                            <button className="btn btn-dark btn-sm">
                              <Link
                                className="text-white text-decoration-none"
                                to={`/blogs/${item.id}`}
                              >
                                Read More
                              </Link>
                            </button>
                          </div>
                        </article>
                      </div>
                    </>
                  );
                })}
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
